import gql from 'graphql-tag';

export const Grocery = gql`
  type Grocery {
    name: String
    amount: String
    unit: String
  }
`;
